import {select, takeEvery} from 'redux-saga/effects';
import trackingActions, {EVENT_CATEGORY} from '../actions/tracking.actions';
import {selectAccountId} from '../selectors/user.selectors';
import epicTracking from 'epic-tracking';
import {TrackingEventTypes} from 'epic-diesel-common/src/constants/Tracking';

const trackEventRequireLogin = eventCategory => {
    return eventCategory === EVENT_CATEGORY.AffiliateMigrate;
};

export function* trackEvent({payload}) {
    const {eventType, ...data} = payload;

    try {
        data.accountId = yield select(selectAccountId);

        if (trackEventRequireLogin(data.eventCategory) && !data.accountId) {
            return;
        }

        /**
         * to-do: look into epic-tracking lib, loses `keywords` from pageView search
         */
        epicTracking.trackEvent(eventType || TrackingEventTypes.Interaction, data);
    } catch (e) {
        console.warn('trackEvent fail', e);
    }
}

function* trackingSaga() {
    yield takeEvery(trackingActions.TYPES.TRACK_EVENT, trackEvent);
}

export default trackingSaga;
